'use client'

import AboveTheFold from '@/components/common/above-the-fold'
import SplashScreen from '@/components/common/splash-screen'
import TheProblem from '@/components/common/the-problem'
import { useSearchPropertyPopup } from '@/context/search-property-popup'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollSmoother } from 'gsap/dist/ScrollSmoother'
import Image from 'next/image'
import { useRef } from 'react'
import PropertyRepresentationForm from '@/components/common/form/PropertyRepresentationForm'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'

if (typeof window !== 'undefined') {
  gsap.registerPlugin(ScrollSmoother, ScrollTrigger, ScrollToPlugin)
}

export default function ContentsHomepage() {
  const rootRef = useRef<HTMLDivElement>(null)
  const { value, setValue } = useSearchPropertyPopup()

  useGSAP(
    () => {
      if (!ScrollTrigger.isTouch) {
        ScrollSmoother.create({
          content: rootRef.current,
          smooth: 1,
          ignoreMobileResize: false,
          effects: true,
          smoothTouch: true,
        })
      }

      // freeze mobile browser search bar when scrolling down.
      // but it causes jittery scroll on mobile, so we disable it for now
      // if (ScrollTrigger.isTouch) {
      //   ScrollTrigger.normalizeScroll(true)
      // }
    },
    {
      scope: rootRef,
    },
  )

  return (
    <>
      <SplashScreen />
      <div ref={rootRef}>
        <AboveTheFold />
        <TheProblem />
      </div>
      <div aria-hidden={!value}>
        <div
          className={`fixed inset-0 transition-all duration-300 ${value ? 'block z-[9999]' : 'hidden z-[-1]'}`}
        >
          <div className="w-full h-full flex items-center justify-center relative overscroll-none">
            <div
              className="bg-black/80 absolute inset-0"
              onClick={() => setValue(false)}
            />
            <div
              className="absolute top-5 right-5 z-20 cursor-pointer"
              onClick={() => setValue(false)}
            >
              <Image
                src="/images/close-x.svg"
                alt="Close"
                width={24}
                height={24}
              />
            </div>
            <div
              className="w-[80%] xl:w-[50%] max-h-[90dvh] absolute z-10 bg-[#e2dbd8] p-10 rounded shadow-lg overflow-y-auto"
              onClick={(event) => event.stopPropagation()}
            >
              <PropertyRepresentationForm />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
